export default __webpack_public_path__ + "static/media/hassan_service_des_etrangers.044f100c.jpg";